import { ThemeConfig } from 'antd';

import { stylesColorConfig } from './colors';

export type ColorConfig = keyof typeof stylesColorConfig;

export const antdTheme: ThemeConfig = {
  components: {
    Modal: { zIndexBase: 10000, zIndexPopupBase: 10000 },
    DatePicker: {
      lineWidth: 2,
      inputFontSize: 16,
      borderRadius: 8,
      controlHeight: 48,
      colorErrorBorderHover: stylesColorConfig.red,
      colorIcon: stylesColorConfig.grey,
      colorBgContainerDisabled: stylesColorConfig['light-grey'],
      colorTextDisabled: stylesColorConfig.black,
      colorError: stylesColorConfig.red,
      colorErrorBorder: stylesColorConfig.red,
      colorBorder: stylesColorConfig.grey,
      hoverBorderColor: stylesColorConfig.blue,
      activeBorderColor: stylesColorConfig.blue,
      activeShadow: 'none',
      errorActiveShadow: 'none',
    },
    Input: {
      lineWidth: 2,
      controlHeight: 45,
      inputFontSize: 16,
      borderRadius: 8,
      colorErrorBorderHover: stylesColorConfig.red,
      colorBgContainerDisabled: stylesColorConfig['light-grey'],
      colorTextDisabled: stylesColorConfig.black,
      colorError: stylesColorConfig.red,
      colorErrorBorder: stylesColorConfig.red,
      colorBorder: stylesColorConfig.grey,
      hoverBorderColor: stylesColorConfig.blue,
      activeBorderColor: stylesColorConfig.blue,
      activeShadow: 'none',
      errorActiveShadow: 'none',
    },
    Select: {
      lineWidth: 2,
      controlHeight: 48,
      optionHeight: 24,
      controlPaddingHorizontal: 16,
      optionPadding: '4px 16px',
      colorBgContainerDisabled: stylesColorConfig['light-grey'],
      colorTextDisabled: stylesColorConfig.black,
      colorTextPlaceholder: stylesColorConfig.grey,
      colorErrorHover: stylesColorConfig.red,
      colorError: stylesColorConfig.red,
      hoverBorderColor: stylesColorConfig.blue,
      colorPrimaryBorderHover: stylesColorConfig.blue,
      colorPrimary: stylesColorConfig.blue,
      colorBorder: stylesColorConfig.grey,
      boxShadowSecondary: 'none',
      motionDurationMid: '0.3s',
    },
    Checkbox: {
      lineWidth: 2,
      colorPrimary: stylesColorConfig.blue,
      colorPrimaryBorder: stylesColorConfig.blue,
      colorBorder: stylesColorConfig.grey,
      colorPrimaryHover: stylesColorConfig.blue,
    },
    Radio: {
      lineWidth: 2,
      dotSize: 16,
      radioSize: 24,
      wrapperMarginInlineEnd: 8,
      colorPrimary: stylesColorConfig.blue,
      colorPrimaryBorderHover: stylesColorConfig.blue,
    },
    Switch: { trackPadding: 4, trackHeight: 32, trackMinWidth: 48, handleSize: 24 },
    Tabs: {
      itemColor: stylesColorConfig.black,
      itemSelectedColor: stylesColorConfig.white,
      itemHoverColor: stylesColorConfig.blue,
      horizontalItemGutter: 0,
      horizontalItemPadding: '12px 16px',
      verticalItemMargin: '0',
      verticalItemPadding: '10px 16px',
    },
    Pagination: {
      itemActiveBg: stylesColorConfig.blue,
      itemLinkBg: stylesColorConfig['light-grey'],
      itemSize: 48,
    },
  },
};
